import { oracleApi } from '../../../api/oracle/oracle-client'
import { createFailureEvent } from 'user-events-segment'
import { Amounts } from '../../../logic/token/amounts'
import { Token } from '../../../logic/token/token'
import { fromWei } from '../../../utils/static-web3'
import { Pool } from '../../../logic/pools/Pool'
import { WithdrawResult } from '../../../api/web3/exit-api'

export interface WithdrawReducerState {
  pool: Pool
}

export interface WithdrawAction {
  type: 'choose-pool' | 'failure' | 'success' | 'change-tab' | 'select-mode'
  pool?: Pool
  result?: WithdrawResult
  data?: Partial<WithdrawResult> & any // TODO: type precisely this
}

export function withdrawReducer(
  state: WithdrawReducerState,
  action: WithdrawAction
): WithdrawReducerState {
  switch (action.type) {
    case 'choose-pool':
      return {
        ...state,
        pool: action.pool!,
      }

    case 'failure':
      fireWithdrawFailureEvent(action.data, state)
      //TODO: should replace/merge the current funnelState
      return state
  }
  return state
}

function fireWithdrawFailureEvent(
  data: Partial<WithdrawResult> & any,
  state: WithdrawReducerState
) {
  const { step, reason, percent, amounts, expected_burnt, hash } = data
  const pool = state.pool
  const poolAddress = pool.address
  const tokens = pool.tokens.map((t: Token) => t.symbol)

  oracleApi.getPrices().then(() => {
    createFailureEvent().withdraw_failure(
      step,
      reason,
      poolAddress,
      tokens,
      percent,
      Amounts.fromMap(amounts).toAnalyticObject(),
      fromWei(expected_burnt, 18),
      oracleApi.calculateBag(Amounts.fromMap(amounts)),
      hash
    )
  })
}
